import Button from "@mui/material/Button";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";

export default function AutoSuggestionGenerationButton() {
  const [isLoading, setIsLoading] = useState(false);
  const { generateAutoSuggestions } = useAPI();

  const handleOnClick = () => {
    setIsLoading(true);
    generateAutoSuggestions()
      .then(() => {
        setIsLoading(false);
        Toast.success("Finished generating auto-suggestions");
      })
      .catch(() => {
        setIsLoading(false);
        Toast.error("Failed to generate auto-suggestions");
      });
  };

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: "pink",
      }}
      onClick={handleOnClick}
    >
      <SpinningIcon isLoading={isLoading} />
      <span style={{ marginLeft: "8px" }}>Generate Auto-Suggestions</span>
    </Button>
  );
}
